<template>
  <div class="nav-wrapper">
    <span>当前位置：</span>
    <span
      :class="{'active':nav.firstrouteName!=''}"
      @click="toPage(nav.firstrouteName)"
    >{{nav.firsttitle}}</span>
    <span class="padd" v-if="nav.secondtitle!=''">&#62;</span>
    <span
      :class="{'active':nav.secondrouteName!=''}"
      @click="toPage(nav.secondrouteName)"
    >{{nav.secondtitle}}</span>
    <span v-if="nav.thirdtitle!=''">&#62;</span>
    <span v-if="nav.thirdtitle!=''">{{nav.thirdtitle}}</span>
  </div>
</template>
<style scoped>
.nav-wrapper {
  font-size: 0;
  margin-bottom: 20px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: ["nav"],
  methods: {
    toPage(url) {
      if (url) {
        this.$router.push({name:url});
      }
    }
  },
  mounted(){
    console.log(this.nav)
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/common/nav.vue